import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters/base-filter-button';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  tradeLicenseName: string;
  dedBusinessName: string;
};

const defaultValues: TInputs = {
  tradeLicenseName: '',
  dedBusinessName: '',
};

export const LicenseDedFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  useEffect(() => {
    if (params.tradeLicenseName || params.dedBusinessName) setIsActive.on();
    else setIsActive.off();
  }, [params.tradeLicenseName, params.dedBusinessName, setIsActive]);

  const { register, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  useEffect(() => {
    setValue('tradeLicenseName', (params.tradeLicenseName as string) ?? '');
    setValue('dedBusinessName', (params.dedBusinessName as string) ?? '');
  }, [params.tradeLicenseName, params.dedBusinessName, setValue]);

  const onSubmit = (data: TInputs) => {
    const newParams: any = { ...params };

    if (data.tradeLicenseName.trim()) newParams.tradeLicenseName = data.tradeLicenseName.trim();
    else delete newParams.tradeLicenseName;

    if (data.dedBusinessName.trim()) newParams.dedBusinessName = data.dedBusinessName.trim();
    else delete newParams.dedBusinessName;

    setPageParams(newParams);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    setValue('tradeLicenseName', (params.tradeLicenseName as string) ?? '');
    setValue('dedBusinessName', (params.dedBusinessName as string) ?? '');
  };

  const handleClear = () => {
    setValue('tradeLicenseName', '');
    setValue('dedBusinessName', '');
    const newParams: any = { ...params };
    delete newParams.tradeLicenseName;
    delete newParams.dedBusinessName;
    setPageParams(newParams);
    onClose();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <FormLabel>Trade License Name</FormLabel>
            <Input size='sm' placeholder='Search by trade license name...' {...register('tradeLicenseName')} />
          </FormControl>
          <FormControl>
            <FormLabel>DED Business Name</FormLabel>
            <Input size='sm' placeholder='Search by DED business name...' {...register('dedBusinessName')} />
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='gray' onClick={handleClear}>
              Clear
            </Button>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
